import { Navigate, Route, Routes, useParams } from "react-router-dom";

import ErrorPlaceholder from "common/components/ErrorPlaceholder";
import Loader from "common/components/Loader";
import {
  ContentContainer,
  ContentHeader,
  ContentScroll,
  PageTitle,
} from "common/layouts/WorkspaceLayout";

import { CampaignProvider } from "../context/CampaignContext";
import useCampaignDetails from "../datahooks/useCampaignDetails";
import CampaignDetails from "./CampaignDetails";
import { CampaignInfoLoader } from "./CampaignInfo";
import CreateCampaign from "./CreateCampaign";

export default function Campaign() {
  const { campaignId } = useParams();
  const { campaign, isLoadingCampaign, campaignError, refetchCampaign } =
    useCampaignDetails(campaignId);

  if (campaignError || isLoadingCampaign) {
    return (
      <ContentContainer>
        <ContentHeader>
          <PageTitle />
        </ContentHeader>
        <ContentScroll className="p-4 gap-4">
          {campaignError ? (
            <ErrorPlaceholder
              errorMessage="Error Loading Campaign"
              onRetry={refetchCampaign}
            />
          ) : (
            <>
              <CampaignInfoLoader />
              <Loader />
            </>
          )}
        </ContentScroll>
      </ContentContainer>
    );
  }
  return (
    <CampaignProvider value={campaign}>
      <Routes>
        <Route path="details/*" element={<CampaignDetails />} />
        <Route path="create/*" element={<CreateCampaign />} />
        {campaign.state === "INIT" ? (
          <Route path="/" element={<Navigate to="create" replace />} />
        ) : (
          <Route path="/" element={<Navigate to="details" replace />} />
        )}
      </Routes>
    </CampaignProvider>
  );
}
